export default __webpack_public_path__ + "static/media/R_wdt_c_cap_4.ba529d53.mp3";